import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {ExternalReviews} from '../../../types/ExternalReviews';
import {CareproviderUnitService} from '../../../services/careprovider-unit.service';
import {ObjectStringNumber} from '../../../types/ObjectStringNumber';
import {ExternalReviewsProsAndConsGrouped} from '../../../types/ExternalReviewsProsAndConsGrouped';
import {ProsAndConsTypeEnum} from '../../../enums/ProsAndConsEnum';
import {ExternalReviewsSummary} from '../../../types/ExternalReviewsSummary';

@Component({
  selector: 'app-external-reviews',
  templateUrl: './external-reviews.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block bg-grey-10 px-4 py-6 rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class ExternalReviewsComponent {
  public externalReviews = input<ExternalReviews>(null);
  // FIXME - remove this conversion after BE will be fixed
  public externalReviewsNormalized = computed<ExternalReviews>(() => {
    const normalizedReviews = this.externalReviews();
    if (normalizedReviews && normalizedReviews.data && normalizedReviews.data.ReviewSummary) {
      normalizedReviews.data.ReviewSummary = this.keysToCamelCase(normalizedReviews.data.ReviewSummary);
    }
    return normalizedReviews;
  });
  public prosAndConsGrouped = computed<ExternalReviewsProsAndConsGrouped>(() => {
    if (
      this.externalReviewsNormalized() &&
      this.externalReviewsNormalized().data &&
      this.externalReviewsNormalized().data.ReviewSummary
    ) {
      return this.careProviderUnitService.groupExternalReviewsItemsByFrequency(
        this.externalReviewsNormalized().data.ReviewSummary.pros,
        this.externalReviewsNormalized().data.ReviewSummary.cons,
      );
    }
  });

  public sourcesString = computed(() => {
    if (
      this.externalReviewsNormalized() &&
      this.externalReviewsNormalized().data &&
      this.externalReviewsNormalized().data.ReviewSummary &&
      this.externalReviewsNormalized().data.ReviewSummary.reviewsSources
    ) {
      return this.getSourceString(this.externalReviewsNormalized().data.ReviewSummary.reviewsSources);
    }
  });
  protected readonly ProsAndConsTypeEnum = ProsAndConsTypeEnum;

  constructor(private careProviderUnitService: CareproviderUnitService) {}

  private getSourceString(sources: ObjectStringNumber): string {
    const entries = Object.entries(sources);
    if (!entries.length) return '';
    const formattedEntries = entries.map(([key, value]) => `${key}&nbsp;(${value})`);
    const lastElement = formattedEntries.pop();
    return formattedEntries.length
      ? `*Sammanfattat från ${formattedEntries.join(', ')} &amp;&nbsp;${lastElement}.`
      : `*Sammanfattat från ${lastElement}.`;
  }

  private keysToCamelCase(obj: ExternalReviewsSummary): ExternalReviewsSummary {
    if (obj !== null && typeof obj === 'object') {
      return Object.entries(obj).reduce((accumulator, [key, value]) => {
        const camelKey = this.toCamelCase(key);
        accumulator[camelKey] = value;
        return accumulator;
      }, {} as ExternalReviewsSummary);
    } else {
      return obj;
    }
  }

  private toCamelCase(str: string): string {
    return str
      .replace(/[-_\s]+(.)?/g, (_, char) => (char ? char.toUpperCase() : ''))
      .replace(/^[A-Z]/, (match) => match.toLowerCase());
  }
}
